export default "__VITE_ASSET__D06xlHSZ__"